<template>
    <b-modal
        :id="modalUUid"
        :ref="modalUUid"
        title="Trigger Review Status?"
        :hide-footer="true"
    >
        <BaseForm
            ref="main_form"
            :settings="reviewFormSettings"
            @success="success"
            @error="handleError"
            @cancel="$bvModal.hide(modalUUid)"
            v-slot="{ save, cancel }"
        >
            <b-row class="mb-1">
                <b-col cols="3"> Internal Comment </b-col>
                <b-col cols="9">
                    <FormElement
                        ref="comment"
                        :elementSettings="reviewFormSettings.formElements.comment"
                        :formSettings="reviewFormSettings"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="primary" @click="save()" class="mr-1">
                        Yes
                    </b-button>
                    <b-button variant="warning" @click="cancel()"
                        >No</b-button
                    >
                </b-col>
            </b-row>
        </BaseForm>
    </b-modal>
</template>

<script>
import { isDifferentAdminAssignedError } from '@/utils/helpers'

export default {
  props: {
    userId: {
      required: true,
      type: Number
    },
    suppressStatusChangeErrorToast: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalUUid: `review-status-confirm-modal${ this.userId }`,
      refreshKey: 'review-status-confirm-modal',
      reviewFormSettings: {
        addUrl: `/api/users/${  this.userId  }/status`,
        method: 'PUT',
        http: this.$httpSupport,
        primaryKey: 'id',
        suppressErrorToast: (errors) => this.suppressStatusChangeErrorToast && isDifferentAdminAssignedError(errors),
        formElements: {
          comment: {
            type: 'textarea',
            defaultValue: '',
            rules: ['required'],
            post_param: 'comment',
            value: '',
            errorClass: 'input-error',
            errorMessage: 'Internal comment is required!',
            isValidated: false,
            place_holder: 'Input internal comment',
            isError: false,
            maxlength: 255
          },
          status: {
            type: 'hidden',
            sub_type: 'hidden',
            defaultValue: 4,
            post_param: 'status',
            rules: ['required'],
            value: 4,
            data: [{ label: 'Review', value: 4 }]
          }
        },
        vueContainer: this
      }
    }
  },
  methods: {
    showForm () {
      this.$bvModal.show(this.modalUUid)

      this.$nextTick(() => {
        this.getFormVue().clearForm()
      })
    },
    success (data) {
      this.$emit('changed', data)
      this.$bvModal.hide(this.modalUUid)
    },
    handleError (errors) {
      if (this.suppressStatusChangeErrorToast && isDifferentAdminAssignedError(errors)) {
        this.$bvModal.hide(this.modalUUid)
      }

      this.$emit('error', errors)
    },
    getFormVue () {
      return this.$refs.main_form
    }
  }
}
</script>

<style>
</style>
